// Specialist Referrals - Constants and Options
// Based on Data Dictionary for refactorization

// ============================================
// PATIENT INFORMATION
// ============================================

export const LANGUAGES = [
  { value: "English", label: "English" },
  { value: "Spanish", label: "Spanish" },
  { value: "Creole", label: "Creole" },
  { value: "Portuguese", label: "Portuguese" },
  { value: "French", label: "French" },
];

export const MEMBER_CONDITIONS = [
  { value: "ACTV", label: "Active" },
  { value: "INACTV", label: "Inactive" },
  { value: "User Added", label: "User Added" },
];

// ============================================
// CLINICAL INFORMATION
// ============================================

/** @deprecated Usar getStatuses('specialist_referral_urgency') de masterDataService — IDs 7,8,9 */
export const URGENCY_LEVELS = [
  { value: "Low Risk", label: "Low Risk", color: "success" },
  { value: "Moderate Risk", label: "Moderate Risk", color: "warning" },
  { value: "Stat / High Risk", label: "Stat / High Risk", color: "error" },
];

export const YES_NO_OPTIONS = [
  { value: "Y", label: "Yes" },
  { value: "N", label: "No" },
];

/** @deprecated Usar searchDiagnoses(searchTerm) de specialistReferralsService */
// Top 30 ICD-10 codes for autocomplete suggestions
export const COMMON_ICD10_CODES = [
  "Z12.11", "E11.65", "H53.8", "M54.50", "M25.561",
  "C61", "R97.20", "F41.9", "G40.909", "I10",
  "G47.30", "K40.90", "M32.9", "R19.5", "K21.9",
  "D50.9", "M06.9", "M54.2", "B19.10", "R76.0",
  "D25.9", "G89.29", "K64.9", "M25.562", "M25.512",
  "H53.9", "N18.32", "L84", "N97.9", "R87.610"
];

/** @deprecated Usar searchReferralReasons(searchTerm) de specialistReferralsService */
// Top 20 reasons for referral suggestions
export const COMMON_REASONS = [
  "Further Evaluation",
  "Evaluation and Treatment",
  "Continue Care",
  "Colonoscopy",
  "Continuation of Treatment",
  "Pain in Right Knee",
  "Colon Cancer Screening",
  "Eye Exam",
  "Type 2 Diabetes",
  "Chronic Pain Syndrome",
  "Lumbago",
  "Pregnancy",
  "Depression",
  "Anxiety",
  "Hypertension",
  "Diabetic Retinopathy Screening",
  "Sleep Apnea",
  "Hernia Repair",
  "Prostate Cancer Screening",
  "Annual Eye Examination"
];

/** @deprecated Usar searchHedisCodes(searchTerm) de specialistReferralsService */
// HEDIS options (15 main values)
export const HEDIS_OPTIONS = [
  { value: "Other / Clinical", label: "Other / Clinical" },
  { value: "36415 - Routine Venipuncture", label: "36415 - Routine Venipuncture" },
  { value: "CARDIO", label: "CARDIO" },
  { value: "- Appropriate Testing for Pharyngitis", label: "Appropriate Testing for Pharyngitis" },
  { value: "OBGYN", label: "OBGYN" },
  { value: "ORTHOPEDIC", label: "ORTHOPEDIC" },
  { value: "UROLOGY", label: "UROLOGY" },
  { value: "OPHTO", label: "OPHTO" },
  { value: "G0328 - Colorectal Screening", label: "G0328 - Colorectal Screening" },
  { value: "-Eye Exam", label: "Eye Exam" },
  { value: "Oncology", label: "Oncology" },
  { value: "ENDO", label: "ENDO" },
  { value: "NEPHRO", label: "NEPHRO" },
  { value: "PSYCH", label: "PSYCH" },
  { value: "PULMONARY", label: "PULMONARY" },
];

// ============================================
// SPECIALIST INFORMATION
// ============================================

/** @deprecated Usar getSpecialistTypes() de specialistReferralsService */
// Normalized list of 30 specialist types
export const SPECIALIST_TYPES = [
  "Gastroenterologist",
  "Ophthalmologist",
  "Orthopedic",
  "Cardiologist",
  "Urologist",
  "Endocrinologist",
  "Pain Management",
  "Neurologist",
  "ENT",
  "OBGYN",
  "General Surgeon",
  "Psychiatrist",
  "Hematologist",
  "GYN",
  "Pulmonology",
  "Rheumatology",
  "Dermatology",
  "Nephrology",
  "Physical Therapy",
  "Behavioral Health",
  "Oncology",
  "Podiatry",
  "Breast Surgeon",
  "Vascular",
  "Infectious Disease",
  "Allergy",
  "Gastric Sleeve",
  "Sleep Medicine",
  "Wound Care",
  "Other"
];

// ============================================
// ADMINISTRATIVE INFORMATION
// ============================================

/** @deprecated Usar getPcps({ locationId, status: 1 }) de masterDataService */
// Providers (22 values)
export const PROVIDERS = [
  { id: "aneilla_id", name: "ALCIN, ANEILLA", pcpNumber: "XXXXX" },
  { id: "laura_id", name: "ARMAS, LAURA", pcpNumber: "XXXXX" },
  { id: "awais_id", name: "AWAIS, SIDDIKI", pcpNumber: "XXXXX" },
  { id: "robert_id", name: "CHARLES APRN, ROBERT", pcpNumber: "XXXXX" },
  { id: "yohanna_id", name: "DENO, YOHANNA", pcpNumber: "XXXXX" },
  { id: "ramandeep_id", name: "DHILLON-GILL, RAMANDEEP", pcpNumber: "XXXXX" },
  { id: "john_id", name: "EDMOND, JOHN", pcpNumber: "XXXXX" },
  { id: "ricardo_id", name: "GASPARD, RICARDO EMMANUEL MD", pcpNumber: "XXXXX" },
  { id: "rakia_id", name: "HAMILTON, RAKIA", pcpNumber: "XXXXX" },
  { id: "yolette_id", name: "JEAN LOUIS, YOLETTE", pcpNumber: "XXXXX" },
  { id: "ann_id", name: "JOLIVAIN, ANN MELISSA", pcpNumber: "XXXXX" },
  { id: "jean_id", name: "MESIDOR, JEAN K", pcpNumber: "XXXXX" },
  { id: "yanela_id", name: "MOLINA-CHUY, YANELA APRN", pcpNumber: "QB1N6" },
  { id: "joseph_id", name: "MOYSE, JOSEPH G", pcpNumber: "145JS" },
  { id: "neliudis_id", name: "NAVARO, NELIUDIS", pcpNumber: "XXXXX" },
  { id: "orly_id", name: "PENA SANCHEZ, ORLY MD", pcpNumber: "146KY" },
  { id: "viviana_id", name: "PERDOMO, VIVIANA", pcpNumber: "XXXXX" },
  { id: "belkys_id", name: "PORRAS, BELKYS", pcpNumber: "5DGW1" },
  { id: "jeanl_id", name: "RENELIEN, JEAN L MD", pcpNumber: "37758" },
  { id: "reynaldo_id", name: "SMITH, REYNALDO PEZZOTTI MD", pcpNumber: "8TP02" },
  { id: "wanda_id", name: "SMITH, WANDA IVELISSE MD", pcpNumber: "XXXXX" },
  { id: "robert_s_id", name: "SADATY, ROBERT", pcpNumber: "51499" }
];

/** @deprecated Usar getCareManagers(locationId) de specialistReferralsService */
// Care Managers (8 values)
export const CARE_MANAGERS = [
  { value: "Dr. Nageda Laurent", label: "Dr. Nageda Laurent" },
  { value: "Idalene Pierre", label: "Idalene Pierre" },
  { value: "Dr. Marsophia Julemis", label: "Dr. Marsophia Julemis" },
  { value: "Dr. Ashley Jules", label: "Dr. Ashley Jules" },
  { value: "Dr. Jean Daniel Pierre", label: "Dr. Jean Daniel Pierre" },
  { value: "Dr. Mischael Volcy", label: "Dr. Mischael Volcy" },
  { value: "Dr. St Hilaire Clarence", label: "Dr. St Hilaire Clarence" },
  { value: "Dr. Rony Saint Fleur", label: "Dr. Rony Saint Fleur" }
];

/** @deprecated Usar getLocations({ clinical: true, status: 1 }) de masterDataService */
// Centers (7 values) with regional manager mapping
export const CENTERS = [
  { value: "FortMyers", label: "Fort Myers", region: "West Coast Manager" },
  { value: "PortSaintLucie", label: "Port Saint Lucie", region: "East Coast Manager" },
  { value: "Lehigh", label: "Lehigh", region: "West Coast Manager" },
  { value: "Naples", label: "Naples", region: "West Coast Manager" },
  { value: "LakeWorth", label: "Lake Worth", region: "East Coast Manager" },
  { value: "FortPierce", label: "Fort Pierce", region: "East Coast Manager" },
  { value: "Immokalee", label: "Immokalee", region: "West Coast Manager" }
];

// Managers (7 values) with center assignments
export const MANAGERS = [
  { value: "Mirlande Joseph", label: "Mirlande Joseph", centers: ["PortSaintLucie", "FortPierce"] },
  { value: "Stephanie Jean Coute", label: "Stephanie Jean Coute", centers: ["FortMyers"] },
  { value: "Barbara Lalanne", label: "Barbara Lalanne", centers: ["Lehigh"] },
  { value: "Berenice Calderon", label: "Berenice Calderon", centers: ["LakeWorth"] },
  { value: "Fabienne Saintfort", label: "Fabienne Saintfort", centers: ["PortSaintLucie"] },
  { value: "Guadalupe Nava", label: "Guadalupe Nava", centers: ["Immokalee"] },
  { value: "Solitair Hollenback", label: "Solitair Hollenback", centers: ["Naples"] }
];

// Regional Managers (2 values)
export const REGIONAL_MANAGERS = [
  { value: "West Coast Manager", label: "West Coast Manager" },
  { value: "East Coast Manager", label: "East Coast Manager" }
];

// Staff members (normalized - 46 values)
export const STAFF_MEMBERS = [
  "Yanela", "Shelda", "Ydeno", "Kerline", "Belkis",
  "Neliudis", "Yvonne", "Awais", "JohnEd", "RobertS",
  "Ramandeep", "Rakia", "Viviana", "Lucinda", "Guadalupe",
  "Stephania", "Osta", "Robertch", "Pezzotti", "Aneilla",
  "Lourdie", "Tirav", "Jolivain", "Wanda", "Yolette",
  "Alejandro", "Berenience", "Vanessa", "Abigail", "Moliejb",
  "Claudia", "Manouchka", "Mcdanna", "Cbrown", "Denise",
  "Marsophia", "Dayamil", "Janvier", "Orly", "Taboada",
  "Barbara", "Jason", "Joseph", "Nicole", "Celenahr", "Valentina"
];

// ============================================
// STATUS AND FOLLOW UP
// ============================================

/** @deprecated Usar getStatuses('specialist_referral_status') de masterDataService — IDs 10-14 */
// Referral Status (5 values)
export const REFERRAL_STATUS = [
  { value: "Referral faxed to specialist", label: "Referral faxed to specialist", color: "info" },
  { value: "Patient left without referral", label: "Patient left without referral", color: "warning" },
  { value: "Called PT about referral", label: "Called PT about referral", color: "info" },
  { value: "Referral was given to PT", label: "Referral was given to PT", color: "success" },
  { value: "PT picked up referral", label: "PT picked up referral", color: "success" }
];

/** @deprecated Usar getStatuses('specialist_referral_followup') de masterDataService — IDs 15-17 */
// Follow Up Status (3 values)
export const FOLLOW_UP_STATUS = [
  { value: "PENDING", label: "Pending", color: "warning" },
  { value: "WORKING", label: "Working", color: "info" },
  { value: "DONE", label: "Done", color: "success" }
];

// ============================================
// HELPER FUNCTIONS
// ============================================

// Color maps work with API statusName values (case-insensitive match)
const URGENCY_COLOR_MAP = {
  "low risk": "success",
  "moderate risk": "warning",
  "stat / high risk": "error",
};

const STATUS_COLOR_MAP = {
  "referral faxed to specialist": "info",
  "patient left without referral": "warning",
  "called pt about referral": "info",
  "referral was given to pt": "success",
  "pt picked up referral": "success",
};

const FOLLOWUP_COLOR_MAP = {
  "pending": "warning",
  "working": "info",
  "done": "success",
};

export const getUrgencyColor = (level) => {
  if (!level) return "default";
  return URGENCY_COLOR_MAP[level.toLowerCase()] || "default";
};

export const getStatusColor = (status) => {
  if (!status) return "default";
  return STATUS_COLOR_MAP[status.toLowerCase()] || "default";
};

export const getFollowUpColor = (status) => {
  if (!status) return "default";
  return FOLLOWUP_COLOR_MAP[status.toLowerCase()] || "default";
};

// Get regional manager based on center
export const getRegionalManager = (centerValue) => {
  const center = CENTERS.find((c) => c.value === centerValue);
  return center?.region || "";
};

// Get managers available for a center
export const getManagersForCenter = (centerValue) => {
  if (!centerValue) return MANAGERS;
  return MANAGERS.filter((m) => m.centers.includes(centerValue));
};

// Get provider by ID
export const getProviderById = (providerId) => {
  return PROVIDERS.find((p) => p.id === providerId) || null;
};

// Get provider by name
export const getProviderByName = (providerName) => {
  return PROVIDERS.find((p) => p.name === providerName) || null;
};

// Format phone number to (XXX) XXX-XXXX
export const formatPhoneNumber = (value) => {
  if (!value) return "";
  const cleaned = value.replace(/\D/g, "");
  const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
  if (!match) return value;

  let formatted = "";
  if (match[1]) formatted = `(${match[1]}`;
  if (match[1]?.length === 3) formatted += ") ";
  if (match[2]) formatted += match[2];
  if (match[2]?.length === 3 && match[3]) formatted += `-${match[3]}`;

  return formatted;
};

// Validate email format
export const isValidEmail = (email) => {
  if (!email) return true; // Optional field
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Normalize ICD-10 code to uppercase
export const normalizeICD10 = (code) => {
  return code ? code.toUpperCase() : "";
};

// Normalize staff name to Title Case
export const normalizeStaffName = (name) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};
